import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

const IMAGE_BASE = "https://online-tech.in/MedicineImage/";

export default function SpecializedBannerDetail() {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBrandData = async () => {
      try {
        const res = await axios.get(
          `https://online-tech.in/api/Medicine/GetMedicineByBrand?Id=${id}`
        );

        // 🔥 FIX HERE
        const list =
          res.data?.data ||
          res.data?.Data ||
          res.data ||
          [];

        setData(Array.isArray(list) ? list : []);
      } catch (err) {
        console.error("Brand API Error:", err);
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchBrandData();
  }, [id]);

  if (loading)
    return <h4 className="text-center mt-5">Loading...</h4>;

  return (
    <div className="px-4 md:px-8 py-6 bg-gray-50 rounded-xl shadow-lg mt-5">
      <h4 className="text-center text-2xl md:text-3xl font-extrabold mb-6
        bg-gradient-to-r from-red-500 via-pink-500 to-orange-400
        bg-clip-text text-transparent tracking-wide">
        Brand Products
      </h4>

      {data.length === 0 ? (
        <p className="text-center">No products found</p>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {data.map((item) => (
            <div
              key={item.id}
              className="border rounded-lg p-3 shadow-sm hover:shadow-md transition bg-white flex flex-col"
            >
              {/* Image */}
              <div className="h-24 flex items-center justify-center mb-2">
                <img
                  src={`${IMAGE_BASE}${item.medicineImage}`}
                  alt={item.name}
                  className="h-full object-contain"
                  onError={(e) => {
                    e.target.src =
                      "https://via.placeholder.com/100?text=No+Image";
                  }}
                />
              </div>

              {/* Name */}
              <h4 className="text-sm font-semibold line-clamp-1">
                {item.name}
              </h4>

              {/* Salt */}
              <p className="text-xs text-gray-500 line-clamp-1">
                {item.saltName}
              </p>

              {/* Strength */}
              <p className="text-xs text-gray-600">
                {item.strength}
              </p>

              {/* Description */}
              <p className="text-[11px] text-gray-400 line-clamp-2 mt-1">
                {item.description}
              </p>

              {/* Bottom */}
              <div className="mt-auto flex items-center justify-between">
                {item.isPrescription && (
                  <span className="text-[10px] text-red-600 font-medium">
                    Prescription Required
                  </span>
                )}

                <button className="ml-auto px-2 py-[4px] text-[13px] bg-green-100 text-green-700 border border-green-600 rounded hover:bg-green-200 transition">
                  Add
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}